import { Button } from '@upcaret/ui';

export function ErrorComponent({ error }: { error: Error }) {
  const errorMessage = error?.message?.toLowerCase() ?? '';

  if (errorMessage.includes('failed to fetch dynamically imported module')) {
    return <div>A new version has been released. Updating...</div>;
  }

  return (
    <div>
      <h1>Oops! Something went wrong</h1>
      <p>{error.message || 'An unexpected error occurred'}</p>
      <Button onClick={window.location.reload}>Retry</Button>
    </div>
  );
}
